import { Box, Grid } from '@chakra-ui/react';
import { AppLink, Image, LANDING_ROUTES, pxToRem } from '@cyberkongz/ui';
import { ExtractedPostWithAssets } from '@features/blog/apiContentful';
import { formatDate, getFeaturedImageSmall } from '@features/blog/utils';

export function BlogPostsTiles({ posts }: { posts: ExtractedPostWithAssets[] }) {
  return (
    <Grid
      css={{
        gridTemplateColumns: ['repeat(2, 1fr)', 'repeat(3, 1fr)', 'repeat(4, 1fr)'],
        columnGap: [4, null, 8],
        rowGap: [12, null, 16],
        mb: 16,
        '@media screen and (max-width: 420px)': {
          gridTemplateColumns: 'repeat(1, 1fr)',
          rowGap: 8,
        },
      }}
    >
      {posts.map(({ dateCreated, title, featuredImage, slug }) => (
        <AppLink href={LANDING_ROUTES.BLOG_POST(slug)} key={slug} css={{ fontWeight: 'medium' }}>
          <Image
            src={getFeaturedImageSmall(featuredImage?.fields.file?.url)}
            alt={featuredImage?.fields.title}
            css={{ width: '100%', maxWidth: ['100%', pxToRem(286)] }}
          />
          <Box
            css={{
              textTransform: 'uppercase',
              mt: 4,
              mb: 2,
              color: 'textTertiary',
              fontSize: 'sm',
            }}
          >
            {formatDate(dateCreated)}
          </Box>
          <Box css={{ fontSize: ['md', 'lg'] }}>{title}</Box>
        </AppLink>
      ))}
    </Grid>
  );
}

/* // FOR Future if needed */
/* <Box css={{ textAlign: 'center' }}>
  <Button variant="display">Show More</Button>
</Box> */
